// extracted by mini-css-extract-plugin
module.exports = {"direction":"WindDirection_direction__3L-Ga","icon":"WindDirection_icon__33tZI","text":"WindDirection_text__1pgvK"};